<script setup>

import { ref, watch, onMounted } from 'vue';

const { importDonnees, selectionne } = defineProps({
  importDonnees: Object,
  selectionne: Boolean
});

const composant = ref(null);

watch(() => selectionne, (sel) => {
	if (sel) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

onMounted(() => {
	if (composant.value != null && selectionne) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

</script>

<template>
	<div class="import-donnees" 
		ref="composant">
		<div class="nom-import">{{ importDonnees.nom }}</div>
		<i v-if="importDonnees.formuleEnErreur" class="fa-solid fa-triangle-exclamation icone erreur" v-tooltip="'Import en erreur'" />
		<i v-else class="icone invisible" />
	</div>
</template>

<style scoped>

.import-donnees {
	display: flex;
	user-select: none;
	padding: 0px 5px;
	align-items: center;
}

.nom-import {
	width: 14rem;
	overflow: hidden;
	text-overflow: ellipsis;
	flex-grow: 1;
}

.icone {
	padding: 1px;
	margin: 2px 4px;
	width: 1rem;
	text-align: center;
}

.erreur {
	color: var(--couleur-valeur-en-erreur);
}

</style>